/**
 * signed_number_controller.js — a "±" button beside a number box (Stimulus).
 *
 * Number boxes on the unit sheet raise the decimal keypad
 * (templates/macros/dynamic_fields.html), which is fastest for readings but has
 * no minus key on iOS or on many Android keyboards. A reading can go below zero
 * (a freezer room at -18), so the box carries this button, which puts a minus
 * in front of the value or takes it away.
 *
 * The keyboard stays up: pressing the button would otherwise move focus off
 * the box and close it, so its pointerdown is cancelled and focus stays where
 * it was. The value stays text; the server coerces it to a number.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input"];

    keepFocus(event) {
        event.preventDefault();
    }

    flip() {
        const input = this.inputTarget;
        const value = input.value.trim();
        input.value = value.startsWith('-') ? value.slice(1) : `-${value}`;
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
